import {
    IonIcon,
    IonButton,
    useIonActionSheet,
    IonNote,
    IonText,
    IonBadge
} from '@ionic/react';
import {
    Row,
    Col
} from 'reactstrap';
import { getMode } from '@ionic/core';
import {
    ellipsisHorizontalSharp,
    ellipsisVerticalSharp,
    trash,
    pencil,
    close,
    send,
    mail,
    cloudDownload,
    people,
    eye,
    chevronDownCircleOutline,
    chevronUpCircleOutline
 } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';
import { OCCUPANT_TYPE, colorTheme } from '../../utils/constants';

// All actions
const A_VIEW = 'View';
const A_EDIT = 'Edit';
const A_CANCEL = 'Cancel';
const A_DELETE = 'Delete';
const A_SEND = 'Send Receipt';
const A_DOWNLOAD = 'Download Receipt';
const A_CHANGE_TENANT = 'Change Tenant';
const A_CHANGE_MEMBER = 'Change Member';



const PaymentListItem = ({
    paymentId, tenantName, amount, unitName, propertyName,
    currency, paymentDate, showDetails, payment, handlePaymentAction,
    onClickAssignTenant, fromSyncedPayments=false, userAllPerms, options
 }) => {

    const [showExtraDetails, setShowExtraDetails] = useState(false);

    const [present] = useIonActionSheet();

    const [extraData, setExtraData] = useState([
        {label: `${options?.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"}`, value: tenantName},
        {label: 'Property', value: propertyName},
        {label: 'Unit', value: unitName},
        {label: 'Date', value: paymentDate},
        {label: 'Id/Number', value: paymentId},
        {label: 'Status', value: payment.status},
        {label: 'Amount', value: amount},
        {label: 'Created By', value: payment.createdBy},
        {label: 'Description', value: payment.description}
    ]);

    const actionsToOmitForNoTenant = [A_SEND, A_DOWNLOAD, A_CHANGE_TENANT, A_CHANGE_MEMBER, A_DELETE]
    const actionsToShowForSyncedPayments = [A_SEND, A_DOWNLOAD, A_CANCEL]
    const actionsRequiringAllPaymentPerms = [A_EDIT, A_DELETE, A_CHANGE_TENANT, A_CHANGE_MEMBER]
    const actionRequiringAllMessagePerms = [A_SEND]
    useEffect(() => {
    }, [tenantName])

    const open = async () => {
        const mode = getMode();
        const canEdit = userAllPerms.payment;
        let iconToShow = canEdit ? pencil : eye;
        const buttons = [{
          text: canEdit ? A_EDIT : A_VIEW,
          role: 'destructive',
          icon: mode !== 'ios' ? iconToShow : '',
          handler: () => {
              handlePaymentAction('edit', paymentId);
          }
        }, {
          text: A_SEND,
          icon: mode !== 'ios' ? send : '',
          handler: () => {
            handlePaymentAction('sendReceipt', paymentId);
          }
        }, {
          text: A_DOWNLOAD,
          icon: mode !== 'ios' ? cloudDownload : '',
          handler: () => {
            handlePaymentAction('downloadReceipt', paymentId);
          }
        }, {
          text: `${options.userAccountType === OCCUPANT_TYPE ? A_CHANGE_TENANT : A_CHANGE_MEMBER}`,
          icon: mode !== 'ios' ? people : '',
          handler: () => {
            handlePaymentAction('reallocate', paymentId);
          }
        },
        {
          text: A_DELETE,
          icon: mode !== 'ios' ? trash : '',
          handler: () => {
            handlePaymentAction('delete', paymentId);
          }
        }, {
          text: A_CANCEL,
          role: 'cancel',
          icon: mode !== 'ios' ? close : '',
          handler: () => {}
        }];

        let filteredButtons = buttons;
        if(!userAllPerms.payment){
          filteredButtons = buttons.filter((b) => !actionsRequiringAllPaymentPerms.includes(b.text));
        }
        if(!userAllPerms.message){
          filteredButtons = filteredButtons.filter((b) => !actionRequiringAllMessagePerms.includes(b.text));
        }
        if(!tenantName){
          filteredButtons = filteredButtons.filter((b) => !actionstoOmitForNoTenant.includes(b.text));
        }
        if(fromSyncedPayments){
          filteredButtons = filteredButtons.filter((b) => actionsToShowForSyncedPayments.includes(b.text));
        }
        present({
          header: tenantName + "  " + amount + " " + currency,
          buttons: filteredButtons
        });
      }

    useEffect(() => {
        setShowExtraDetails(showDetails);
    }, [showDetails])



    return (<div className='mx-1 mx-md-4' key={paymentId}>
        <Row style={{width: '100%'}} className='my-2 mx-0 py-1 shadow-sm rounded'>
          <Row className='rounded mx-0 px-0'
          >
            <Col id='payment-page-expand-details' onClick={ () => { setShowExtraDetails(!showExtraDetails)} } xs={8} md={6}>
              <Row>
              <Col xs={12} md={5}>
                {tenantName?
                  <strong>{tenantName}&nbsp;
                  <IonIcon
                    style={{fontSize: '20px', color: 'var(--ion-color-primary)', marginRight: '10px' }}
                    icon={!showExtraDetails ? chevronDownCircleOutline : chevronUpCircleOutline}
                  ></IonIcon>
                  </strong>:
                  <IonButton onClick={(e) => { onClickAssignTenant(paymentId) }} fill="outline">
                        Assign {options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"}
                    </IonButton>
                      }
                    </Col>
              <Col xs={12} md={5}>
                <IonNote className='text-sm md:text-base'>{unitName}{(unitName && propertyName)? " | ": ""}</IonNote> &nbsp;
                <IonNote className='text-sm md:text-base'>{propertyName}</IonNote>
              </Col>
              </Row>
            </Col>

            <Col className='px-0' xs={3} md={5}>
              <Row>
              <Col className='px-0' xs={12} md={6}>
                <IonText>
                  <strong>{amount}</strong> &nbsp;
                  <IonBadge color="light">
                    <span className='text-sm md:text-base' style={{fontSize: '11px'}}>{currency}</span>
                  </IonBadge>
                </IonText>
              </Col>
              <Col className='px-0' xs={12} md={6}>
                <IonNote className='text-sm md:text-base'>{paymentDate}</IonNote>
              </Col>
              </Row>
            </Col>

            <div style={{width: '25px', color: 'var(--ion-color-primary)'}} className='my-0 px-0 py-1 d-block d-md-none'>
                  <IonIcon onClick={open} size="large" aria-hidden="true"  icon={ellipsisVerticalSharp} />
            </div>
            <div style={{width: '50px', color: 'var(--ion-color-primary)'}} className='my-0 px-0 py-0 d-none d-md-block'>
                  <IonIcon id='payment-page-menu-items' onClick={open} size="large" aria-hidden="true"  icon={ellipsisHorizontalSharp} />
            </div>
          </Row>

            {showExtraDetails && (<Row
              style={{backgroundColor: colorTheme["primary"]["25"] }}
              className='mx-0 px-0 mb-2 py-3 rounded tenant-list-row'>
              <Row>
                <IonButton 
                  fill="outline"
                  onClick={(e) => {
                    e.stopPropagation();
                    open();
                  }}
                >
                  Options
                </IonButton>
              </Row>
              { extraData.map((data, index) => (
                <Row key={index} className='border-bottom my-1 mx-1'>
                  <Col className='px-0' xs={4} md={3}><strong>{data.label}</strong></Col>
                  <Col xs={8} md={8}>
                    <span style={{fontSize: '16px'}}>{data.value}</span>
                  </Col>
                </Row>
              ))}
            </Row>)}
            </Row>
    </div>);
}

export default PaymentListItem;